"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alphalendUserPortfolioQuery = void 0;
exports.alphalendUserPortfolioQuery = `
query GetUserPortfolio($positionCapId: String!) {
    userPortfolio(positionCapId: $positionCapId) {
        netWorth,
    	suppliedAmounts,
    	borrowedAmounts
    }
}`;
//# sourceMappingURL=userPortfolio.js.map